export type FormStatusType = "failed" | "passed" | undefined;

interface FormStatusMessageProps {
  status: FormStatusType;
}

export function ContactFormStatusMessage({ status }: FormStatusMessageProps) {
  const containerStyles = "mb-6";
  const titleStyles = "text-2xl font-bold text-gray-800 mb-1";
  const messageStyles = "text-gray-600";

  switch (status) {
    case "failed":
      return (
        <div className={containerStyles}>
          <h2 className={titleStyles}>Help us find other studies for you</h2>
          <p className={messageStyles}>
            While you aren't eligible for this specific study, we have many
            other clinical trials that might be better suited for you. Complete
            this form to help us match you with appropriate studies.
          </p>
        </div>
      );
    case "passed":
      return (
        <div className={containerStyles}>
          <h2 className={titleStyles}>Great news!</h2>
          <p className={messageStyles}>
            You qualify for the next stage of study screening with the research
            team. They will call you to discuss appointments and compensation.
          </p>
        </div>
      );
    default:
      return null;
  }
}
